import EnvioTrabajos from "../components/EnvioTrabajos";


function Callforpapers() {
  return (
    <>
      <div className="margin layout8 ">
     
<EnvioTrabajos></EnvioTrabajos>
      </div>
    </>
  );
}

export default Callforpapers;
